import {
  ADVANCED,
  BRANDS,
  BUTTERLFY,
  COMPETITIVE,
  DEFAULT,
  DETAILED,
  DIFFERENTIATION,
  FILTERS,
  GLOBAL,
  MARKETS,
  PERCEPTUAL,
  POINT_IN_TIME,
  PRE_POST,
  PROFILE,
  QUESTION_OPTIONS,
  REPUTATION,
  SECONDARY_BRANDS,
  SEGMENTS,
  TREND,
  URL_BY_BRAND,
  URL_BY_MARKET,
  URL_BY_SEGMENT,
  VISIBILITY,
} from "@/constant/constantsThrougoutProject";
import { ROUTES_CHILDREN_LOOKUP } from "@/routes/routes";
import type { MarketAdapterType } from "@/store/slices/markets/marketsSlice";
import { DateTime } from "luxon";
export const PERIOD_KEYS: any = {
  "P-W": "P_W",
  "P-M": "P_M",
  "P-Q": "P_Q",
  "MV-1": "MV_1",
  "MV-2": "MV_2",
  "MV-4": "MV_4",
  "MV-8": "MV_8",
  "MV-12": "MV_12",
};

export const OLD_URLS: string[] = [
  "/segments/equity",
  "/segments/advertising",
  "/segments/conversion",
  "/segments/emotional",
  "/segments/trends",
  "/segments/profile",
  "/segments/reputation",
  "/segments/visibility",
  "/competitive/equity",
  "/competitive/advertising",
  "/competitive/conversion",
  "/competitive/emotional",
  "/competitive/trends",
  "/competitive/profile",
  "/competitive/reputation",
  "/competitive/visibility",
  "/global/equity",
  "/global/advertising",
  "/global/conversion",
  "/global/emotional",
  "/global/trends",
  "/global/profile",
  "/global/reputation",
  "/global/visibility",
  "/advanced/butterfly",
  "/advanced/prepost",
  "/advanced/perceptual",
  "/advanced/differentiation",
  "/advanced/reputation",
  "/advanced/visibility",
  "/questions/segment",
  "/questions/brand",
];

const trendResponseMetricMapping: any = {
  "momentum-positive": "positiveNetMomentum",
  "momentum-neutral": "neutralNetMomentum",
  "momentum-negative": "negativeNetMomentum",
  "momentum-net": "netNetMomentum",
  "consideration-positive": "positiveConsideration",
  "consideration-negative": "negativeConsideration",
  "consideration-absolutely": "absolutelyConsideration",
  "consideration-possibly": "possiblyConsideration",
  "consideration-notlikely": "notlikelyConsideration",
  "consideration-never": "neverConsideration",
  "quality-positive": "positiveHighQuality",
  "quality-neutral": "neutralHighQuality",
  "quality-negative": "negativeHighQuality",
  "quality-net": "netHighQuality",
  "recommend-positive": "positiveRecommend",
  "recommend-neutral": "neutralRecommend",
  "recommend-negative": "negativeRecommend",
  "recommend-net": "netRecommend",
};

export function parseOldURLParams(queryString: URLSearchParams) {
  const result: Record<string, string | number | string[] | number[]> = {};
  for (const [key] of queryString.entries()) {
    if (key === "questionOptions" || key === "market" || key === "markets") {
      result[key] = queryString.getAll(key);
    } else if (
      key === "brands" ||
      key === "brand" ||
      key === "segments" ||
      key === "filters"
    ) {
      result[key] = queryString.getAll(key).map((val) => Number(val));
    } else {
      result[key] = queryString.get(key) as string;
    }
  }
  return result;
}

export function getPathNameOfNewApplication({
  module,
  screenType,
  group,
  metric,
  mode,
  chartType,
  visualizationType,
}: {
  module: string;
  screenType: string;
  group: string;
  metric: string;
  chartType: string;
  mode: string;
  visualizationType: string;
}) {
  if (screenType === "TRENDS") {
    let path = group?.toLowerCase();
    let subPath = URL_BY_BRAND;
    if (
      module?.toLowerCase() === "segments" ||
      module?.toLowerCase() === "detailed"
    ) {
      subPath = URL_BY_SEGMENT;
    } else if (module?.toLowerCase() === "global") {
      subPath = URL_BY_MARKET;
    }
    return {
      pathname: `/${path}/${subPath}`,
      mode: TREND,
      visualizationType: DEFAULT,
    };
  } else if (screenType === "PROFILE") {
    let path = "equity";
    if (metric?.toLowerCase() === "conversionfunnel") {
      path = "conversion";
    } else if (metric?.toLowerCase() === "equity") {
      path = "equity";
    } else if (metric?.toLowerCase() === "personification") {
      path = "emotional";
    } else if (metric?.toLowerCase() === "advertising") {
      path = "advertising";
    }
    let subPath = URL_BY_BRAND;
    if (
      module?.toLowerCase() === "segments" ||
      module?.toLowerCase() === "detailed"
    ) {
      subPath = URL_BY_SEGMENT;
    } else if (module?.toLowerCase() === "global") {
      subPath = URL_BY_MARKET;
    }
    return {
      pathname: `/${path}/${subPath}`,
      mode: POINT_IN_TIME,
      visualizationType: PROFILE,
    };
  } else if (screenType === REPUTATION || screenType === VISIBILITY) {
    let subPath = URL_BY_BRAND;
    if (module === DETAILED) {
      subPath = URL_BY_SEGMENT;
    } else if (module === COMPETITIVE || module === ADVANCED) {
      subPath = URL_BY_BRAND;
    } else if (module === GLOBAL) {
      subPath = URL_BY_MARKET;
    }
    return {
      pathname: `/${screenType?.toLowerCase()}/${subPath}`,
      mode: mode ?? POINT_IN_TIME,
      visualizationType: visualizationType ?? DEFAULT,
    };
  } else if (module?.toLowerCase() === "advanced") {
    if (
      screenType?.toLowerCase() === "PREPOST"?.toLowerCase() ||
      screenType?.toLowerCase() === "PRE_POST"?.toLowerCase()
    ) {
      let path = "equity";
      if (group?.toLowerCase() === "conversion") {
        path = "conversion";
      } else if (group?.toLowerCase() === "equity") {
        path = "equity";
      } else if (group?.toLowerCase() === "emotional") {
        path = "emotional";
      } else if (group?.toLowerCase() === "advertising") {
        path = "advertising";
      }
      return {
        pathname: `/${path}/${URL_BY_BRAND}`,
        mode: PRE_POST,
        visualizationType: DEFAULT,
      };
    } else if (
      screenType?.toLowerCase() === DIFFERENTIATION?.toLowerCase() ||
      screenType?.toLowerCase() === PERCEPTUAL?.toLowerCase() ||
      screenType?.toLowerCase() === BUTTERLFY?.toLowerCase()
    ) {
      let vizType = DIFFERENTIATION;
      if (screenType?.toLowerCase() === PERCEPTUAL?.toLowerCase()) {
        vizType = PERCEPTUAL;
      } else if (screenType?.toLowerCase() === BUTTERLFY?.toLowerCase()) {
        vizType = BUTTERLFY;
      }
      return {
        pathname: `/emotional/${URL_BY_BRAND}`,
        mode: POINT_IN_TIME,
        visualizationType: vizType,
      };
    }
  } else if (module?.toLowerCase() === "questions") {
    let subPath = URL_BY_BRAND;
    if (screenType === "SEGMENT") {
      subPath = URL_BY_SEGMENT;
    }
    return {
      pathname: `/exclusivequestions/${subPath}`,
      mode: mode,
      visualizationType:
        visualizationType === "TABLE"
          ? "TABLE"
          : mode === TREND
            ? "LINE"
            : "BAR",
    };
  } else if (
    module?.toLowerCase() === "segments" ||
    module?.toLowerCase() === "competitive" ||
    module?.toLowerCase() === "global" ||
    module?.toLowerCase() === "detailed"
  ) {
    let subPath = URL_BY_BRAND;
    if (
      module?.toLowerCase() === "segments" ||
      module?.toLowerCase() === "detailed"
    ) {
      subPath = URL_BY_SEGMENT;
    } else if (module?.toLowerCase() === "global") {
      subPath = URL_BY_MARKET;
    }
    return {
      pathname: `/${screenType?.toLowerCase()}/${subPath}`,
      mode: POINT_IN_TIME,
      visualizationType: chartType === "SECONDARY" ? "BAR" : DEFAULT,
    };
  }
  return {
    pathname: `/equity/${URL_BY_BRAND}`,
    mode: POINT_IN_TIME,
    visualizationType: DEFAULT,
  };
}

export function getNewURL(url: string, markets: MarketAdapterType) {
  const result = parseOldURLParams(new URLSearchParams(url));
  if (!result?.visualizationType) {
    result["visualizationType"] = "DEFAULT";
  }
  const pathnameDetail: any = getPathNameOfNewApplication({
    module: result?.module as string,
    screenType: result?.screenType as string,
    group: result?.group as string,
    metric: result?.metric as string,
    visualizationType: (result?.visualizationType === "STACKED_BAR"
      ? "PROFILE"
      : result?.visualizationType) as string,
    mode: (result?.viewMode || result?.mode) as string,
    chartType: result?.chartType as string,
  });
  const finalParams: any = {};
  Object.entries(result)?.forEach(([key, value]: any[]) => {
    if (key === "audienceType") {
      finalParams["base"] = value;
    } else if (key === "statTest") {
      if (
        value === "POP" ||
        value === "PTP" ||
        value === "YOY" ||
        value === "NONE"
      ) {
        finalParams["statTest"] = value;
      } else if (value === "true" || value === true) {
        finalParams["statTest"] = "POP";
      } else {
        finalParams["statTest"] = "NONE";
      }
    } else if (key === "periodType" || key == "postPeriodType") {
      finalParams[key] = value;
    } else if (
      key === "periodStartDate" ||
      key === "periodEndDate" ||
      key === "postStartDate" ||
      key === "postEndDate"
    ) {
      if (value?.length === 8) {
        finalParams[key] = DateTime.fromFormat(value, "yyyyMMdd").toFormat(
          "yyyy-MM-dd",
        );
      }
    } else if (key === "intervalType") {
      finalParams["period"] = PERIOD_KEYS[value] || value;
    } else if (key === "market" || key === "markets") {
      const marketIds = value
        ?.map((val: string) => {
          const market = markets?.ids?.find((marketId: number) => {
            if (markets?.entities?.[marketId]?.identity === val) {
              return true;
            }
            return false;
          });
          if (market) {
            return market;
          }
          return null;
        })
        .filter((val: any) => val !== null);
      finalParams["markets"] = marketIds;
    } else if (key === "visualizationType") {
      finalParams["visualizationType"] = pathnameDetail["visualizationType"];
    } else if (key === "brand" || key === "brands") {
      if (pathnameDetail?.visualizationType === DIFFERENTIATION) {
        finalParams["brands"] = value?.slice(0, 1);
        finalParams["secondaryBrands"] = value?.slice(1);
      } else if (pathnameDetail?.visualizationType === PERCEPTUAL) {
        finalParams["brands"] = value;
      } else if (pathnameDetail?.visualizationType === BUTTERLFY) {
        finalParams["brands"] = value?.slice(0, 1);
        finalParams["secondaryBrands"] = value?.slice(1);
      } else {
        finalParams["brands"] = value;
      }
    } else if (
      key === "segments" ||
      key === "filters" ||
      key === "questionOptions"
    ) {
      finalParams[key] = value;
    } else if (key === "metric" && pathnameDetail?.mode === "TREND") {
      finalParams["trendsMetric"] = value?.toLowerCase();
    } else if (key === "response" && pathnameDetail?.mode === "TREND") {
      finalParams["trendsResponse"] =
        trendResponseMetricMapping[
          `${
            typeof result?.metric === "string"
              ? result?.metric?.toLowerCase()
              : ""
          }-${value?.toLowerCase()}`
        ];
    } else if (key === "viewId" || key === "groupedBy") {
      finalParams[key] = value;
    } else if (
      key === "group" &&
      pathnameDetail?.visualizationType === "PROFILE"
    ) {
      finalParams["profileGroup"] = value;
    } else if (
      key === "metric" &&
      pathnameDetail?.visualizationType === "PROFILE"
    ) {
      finalParams["profileMetric"] = value;
    } else if (
      key === "response" &&
      pathnameDetail?.visualizationType === "PROFILE"
    ) {
      finalParams["profileResponse"] = value;
    } else if (key === "scoreType") {
      finalParams["scoreType"] = value;
    }
  });
  finalParams["mode"] = pathnameDetail["mode"];

  const currentPathConfig = ROUTES_CHILDREN_LOOKUP[pathnameDetail.pathname];
  let mode: string =
    typeof pathnameDetail?.mode === "string"
      ? pathnameDetail?.mode
      : "POINT_IN_TIME";
  if (
    mode === POINT_IN_TIME &&
    (pathnameDetail?.visualizationType === PERCEPTUAL ||
      pathnameDetail?.visualizationType === BUTTERLFY ||
      pathnameDetail?.visualizationType === DIFFERENTIATION ||
      pathnameDetail?.visualizationType === PROFILE)
  ) {
    mode = pathnameDetail.visualizationType;
  }
  const urlParams = new URLSearchParams();
  currentPathConfig?.urlKeysMapping?.[
    (currentPathConfig?.modeOptions?.includes(mode) && mode) || "POINT_IN_TIME"
  ]?.forEach((key: string) => {
    if (
      key === MARKETS ||
      key === BRANDS ||
      key === FILTERS ||
      key === SECONDARY_BRANDS ||
      key === SEGMENTS ||
      key === QUESTION_OPTIONS
    ) {
      if (finalParams[key]?.length > 0) {
        finalParams[key]?.map((val: any) => urlParams.append(key, val));
      }
    } else if (finalParams[key]) {
      urlParams.append(key, finalParams[key]);
    }
  });
  return { pathname: pathnameDetail?.pathname, url: urlParams?.toString() };
}
